import { useIntercomStore } from "@/store/intercomStore";
import { useCookieConsentStore } from "@/store/cookieConsentStore";

export default defineNuxtRouteMiddleware(() => {
  // Skip middleware on server
  if (import.meta.server) return;

  const cookieConsentStore = useCookieConsentStore();
  if (!cookieConsentStore.areFunctionalCookiesEnabled) return;

  const intercomStore = useIntercomStore();
  intercomStore.bootIntercom();
});
